import ResourceTrigger from '@triggers/ResourceTrigger'

class CopyEventTrigger extends ResourceTrigger

  @triggerConfig: ->
    computed:
      defaultTriggerName: -> 'copy_event'

    methods:
      modalConfig: -> { originalName: 'this event' }
      modalData: -> { name: null }

export default CopyEventTrigger